var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { iconButton } from './shared';
const MAX_STACK = 4; // older toasts beyond this drop — a flood must not wall the screen
let VitesseResultToast = class VitesseResultToast extends LitElement {
    constructor() {
        super(...arguments);
        this.toasts = [];
        this.nextID = 1;
    }
    static { this.styles = [
        iconButton,
        css `
      :host {
        position: fixed;
        right: 18px;
        bottom: 18px;
        z-index: 2147483000; /* above app chrome; native <dialog> top layer still wins */
        display: flex;
        flex-direction: column-reverse; /* newest visually on top */
        gap: 10px;
        pointer-events: none; /* the gaps must not eat clicks */
      }
      .toast {
        pointer-events: auto;
        width: 380px;
        max-width: calc(100vw - 36px);
        background: var(--card-bg);
        border: 1px solid var(--border-color);
        border-left: 3px solid var(--red);
        border-radius: 10px;
        box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
        padding: 12px 14px;
        color: var(--text-primary);
        font-size: 13px;
      }
      .head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 6px;
      }
      .heading {
        font-weight: 600;
        flex: 1;
        min-width: 0;
      }
      .item + .item {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px dashed var(--border-color);
      }
      .explanation {
        line-height: 1.45;
      }
      .remedy-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
      }
      .remedy {
        color: var(--text-secondary, var(--text-primary));
        font-size: 12px;
        line-height: 1.4;
        flex: 1;
        min-width: 0;
      }
      .chip {
        flex: none;
        border: 1px solid var(--border-color);
        background: transparent;
        color: var(--text-primary);
        border-radius: 999px;
        padding: 3px 12px;
        font: 600 12px/1.4 inherit;
        cursor: pointer;
      }
      .chip:hover {
        border-color: var(--blue, #1a8cd8);
        color: var(--blue, #1a8cd8);
      }
      .close {
        flex: none;
      }
    `,
    ]; }
    /** Show one failure toast (its full denial suite). Newest on top; the stack is
     *  bounded — the oldest drops past MAX_STACK. */
    push(t) {
        const lt = { ...t, id: this.nextID++ };
        const ttl = t.ttlMs ?? 8000;
        if (ttl > 0)
            lt.timer = window.setTimeout(() => this.dismiss(lt.id), ttl);
        const next = [...this.toasts, lt];
        while (next.length > MAX_STACK) {
            const dropped = next.shift();
            if (dropped?.timer)
                clearTimeout(dropped.timer);
        }
        this.toasts = next;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        for (const t of this.toasts)
            if (t.timer)
                clearTimeout(t.timer);
    }
    dismiss(id) {
        const t = this.toasts.find((x) => x.id === id);
        if (t?.timer)
            clearTimeout(t.timer);
        this.toasts = this.toasts.filter((x) => x.id !== id);
    }
    // Hovering pauses auto-dismiss — reading multi-remedy suites takes longer than a TTL.
    hold(t) {
        if (t.timer) {
            clearTimeout(t.timer);
            t.timer = undefined;
        }
    }
    act(item) {
        this.dispatchEvent(new CustomEvent('vitesse-result-action', {
            detail: { code: item.code, action: item.action },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `${this.toasts.map((t) => html `
        <div class="toast" role="alert" @mouseenter=${() => this.hold(t)}>
          <div class="head">
            <span class="heading">${t.heading || 'Action refused'}</span>
            <button class="icon-btn close" title="Dismiss" @click=${() => this.dismiss(t.id)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          ${t.items.map((it) => html `
              <div class="item">
                <div class="explanation">${it.explanation}</div>
                ${it.remedy || it.action
            ? html `<div class="remedy-row">
                      <span class="remedy">${it.remedy ?? ''}</span>
                      ${it.action ? html `<button class="chip" @click=${() => this.act(it)}>${it.action}</button>` : nothing}
                    </div>`
            : nothing}
              </div>
            `)}
        </div>
      `)}`;
    }
};
__decorate([
    state()
], VitesseResultToast.prototype, "toasts", void 0);
VitesseResultToast = __decorate([
    customElement('vitesse-result-toast')
], VitesseResultToast);
export { VitesseResultToast };
//# sourceMappingURL=vitesse-result-toast.js.map